import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbComponent } from '@shared/components/breadcrumb/breadcrumb.component';
import { ErrorLogService } from '@shared/services/errorhandler/error-log.service';
import { AccordionModule } from 'primeng/accordion';
import { Subscription } from 'rxjs';

interface CacheList {
  key: string;
  value: string;
}

@Component({
  selector: 'app-cache-viewer',
  standalone: true,
  imports: [
    CommonModule,
    BreadcrumbComponent,
    AccordionModule
  ],
  templateUrl: './cache-viewer.component.html',
  styleUrl: './cache-viewer.component.scss'
})
export class CacheViewerComponent implements OnInit, OnDestroy {

  sub?: Subscription;
  cacheList?: any;
  category?: string;

  constructor(
    private route: ActivatedRoute,
    private errorLogService: ErrorLogService
  ) { }

  ngOnInit(): void {
    this.sub = this.route.params.subscribe(params => {
      const cacheType = params['id'];

      if (cacheType === 'local') {
        this.loadLocalCache();
      } else if (cacheType === 'session') {
        this.loadSessionCache();
      }
      else if (cacheType === 'error') {
        this.loadErrorLog();
      }
    });
  }

  loadLocalCache(): void {
    this.category = 'Local Storage Cache';
    let cacheList: CacheList[] = [];
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key) {
        let value = localStorage.getItem(key) || '';
        if (value) {
          try {
            value = JSON.parse(value);
            cacheList.push({
              key: key,
              value: JSON.stringify(value, null, 2)
            });
          } catch (e) {
            this.errorLogService.logError(`Error parsing local cache - ${e}`);
          }
        }
      }
    }
    this.cacheList = cacheList;
  }

  loadSessionCache(): void {
    this.category = 'Local Session Cache';
    let cacheList: CacheList[] = [];
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (key) {
        let value = sessionStorage.getItem(key) || '';
        if (value && key !== 'errorLog') {
          try {
            value = JSON.parse(value);
            cacheList.push({
              key: key,
              value: JSON.stringify(value, null, 2)
            });
          } catch (e) {
            this.errorLogService.logError(`Error parsing session cache - ${e}`);
          }
        }
      }
    }
    this.cacheList = cacheList;
  }

  loadErrorLog(): void {
    this.category = 'Error Log';
    let cacheList: CacheList[] = [];
    const errorLogs = sessionStorage.getItem('errorLog');
    if (errorLogs) {
      const logs = errorLogs ? JSON.parse(errorLogs) : [];
      if (logs && logs.length > 0) {
        for (let i = 0; i < logs.length; i++) {
          cacheList.push({
            key: `Error Log ${i + 1}`,
            value: logs[i]
          });
        }
      }
      else {
        cacheList.push({
          key: 'Error Log',
          value: 'No error logs found.'
        });
      }
    }
    else {
      cacheList.push({
        key: 'Error Log',
        value: 'No error logs found.'
      });
    }
    this.cacheList = cacheList;
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
